import { Routes } from '@angular/router';
import { MainLayoutComponent } from './core/layout/main-layout.component';

export const appRoutes: Routes = [
  {
    path: '',
    component: MainLayoutComponent,
    children: [
      {
        path: 'inicio',
        loadChildren: () =>
          import('./features/home/home.routes').then((m) => m.HOME_ROUTES),
      },
      {
        path: 'programas',
        redirectTo: 'inicio/programas',
        pathMatch: 'full',
      },
      {
        path: 'projetos',
        redirectTo: 'inicio/projetos',
        pathMatch: 'full',
      },
      {
        path: 'demandas',
        redirectTo: 'inicio/demandas',
        pathMatch: 'full',
      },
      {
        path: '',
        pathMatch: 'full',
        redirectTo: 'inicio',
      },
    ],
  },
  {
    path: 'acesso-negado',
    loadComponent: () =>
      import('./core/auth/pages/access-denied.page').then((m) => m.AccessDeniedPage),
  },
];
